<template>
  <div>
    <b-button @click="showForm = !showForm" variant="link">{{text}}</b-button>

    <b-modal id="modal-1" :title="text + ' User'" v-model="showForm" :lazy="true"
      @ok="handleOk"
      @cancel="handleCancel">

      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          :state="nameState"
          label="Name"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-input
            id="name-input"
            v-model="thisUser.name"
            :state="nameState"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="emailState"
          label="Email"
          label-for="email-input"
          invalid-feedback="Email is required"
        >
          <b-form-input
            id="email-input"
            type="email"
            v-model="thisUser.email"
            :state="emailState"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="emailState"
          label="Phone"
          label-for="phone-input"
          invalid-feedback="Invalid phone number"
        >
          <b-form-input
            id="phone-input"
            type="tel"
            v-model="thisUser.phoneNumber"
            :state="phoneNumberState"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="rolesState"
          label="Roles"
          label-for="roles-input"
          invalid-feedback="At least one role is required"
        >

        <b-form-select
          v-model="thisUser.roles"
          :options="roles"
          multiple
          :select-size="3"
          :state="rolesState"
          required></b-form-select>
        </b-form-group>

        <!-- <b-form-group label="User Type">
          <b-form-radio v-model="thisUser.type" name="user-type" value="Student">Student</b-form-radio>
          <b-form-radio v-model="thisUser.type" name="user-type" value="Instructor">Instructor</b-form-radio>
          <b-form-radio v-model="thisUser.type" name="user-type" value="None">None</b-form-radio>
        </b-form-group> -->

        <b-form-group
          label="Company"
          label-for="company-input"
        >
          <b-form-input
            id="company-input"
            v-model="thisUser.company"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Introduction"
          label-for="introduction-input"
        >
          <b-form-textarea
            id="introduction-input"
            v-model="thisUser.introduction"
            rows="3"
            maxRows="6"
          ></b-form-textarea>
        </b-form-group>

        <b-form-checkbox
          id="checkbox-1"
          v-model="thisUser.updatePassword"
          name="checkbox-1"
          v-if="thisUser.id > 0"
        >
          Change Password
        </b-form-checkbox>

        <b-form-group
          :state="passwordState"
          label="Password"
          label-for="password-input"
          invalid-feedback="Password is required"
          v-if="thisUser.updatePassword || thisUser.id === 0"
        >
          <b-form-input
            id="password-input"
            type="password"
            v-model="thisUser.password"
            :state="passwordState"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="confirmPasswordState"
          label="Confirm Password"
          label-for="confirm-password-input"
          invalid-feedback="Password does not match"
          v-if="thisUser.updatePassword || thisUser.id === 0"
        >
          <b-form-input
            id="confirm-password-input"
            type="password"
            v-model="thisUser.confirmPassword"
            :state="confirmPasswordState"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-checkbox
          v-model="thisUser.requiresPasswordReset"
        >
          Require Password Reset
        </b-form-checkbox>

        <b-form-checkbox
          v-model="thisUser.disabled"
        >
          Disabled
        </b-form-checkbox>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { validateEmail, validatePhone } from '../../../../_helpers/validations'

export default {
  props: [ 'text', 'user' ],
  name: 'UserForm',
  data () {
    return {
      showForm: false,
      thisUser: null,
      submitted: false,
      roles: [
        'Administrator',
        'Student',
        'Instructor'
      ]
    }
  },
  created () {
    var vm = this
    vm.thisUser = JSON.parse(JSON.stringify(this.user))
  },
  computed: {
    emailState () {
      if (!this.submitted) {
        return null
      }
      return validateEmail(this.thisUser.email)
    },
    phoneNumberState () {
      if (!this.submitted) {
        return null
      }
      if (this.thisUser.phoneNumber !== null && this.thisUser.phoneNumber.length > 0) {
        console.log('validating phone ' + this.thisUser.phoneNumber)
        return validatePhone(this.thisUser.phoneNumber)
      }
      return true
    },
    rolesState () {
      if (!this.submitted) {
        return null
      }
      return this.thisUser.roles.length > 0
    },
    nameState () {
      if (!this.submitted) {
        return null
      }
      return this.thisUser.name !== null && this.thisUser.name.length > 4
    },
    passwordState () {
      if (!this.submitted) {
        return null
      }
      if (this.thisUser.updatePassword || this.thisUser.id === 0) {
        return this.thisUser.password.length > 4
      } else {
        return true
      }
    },
    confirmPasswordState () {
      if (!this.submitted) {
        return null
      }
      if ((this.thisUser.updatePassword || this.thisUser.id === 0)) {
        return this.thisUser.password === this.thisUser.confirmPassword
      } else {
        return true
      }
    }
  },
  methods: {
    validate () {
      this.submitted = true
      return this.passwordState &&
      this.emailState &&
      this.confirmPasswordState &&
      this.nameState &&
      this.rolesState &&
      this.phoneNumberState
    },
    handleOk (evt) {
      evt.preventDefault()

      var vm = this
      // Exit when the form isn't valid
      if (!this.validate()) {
        return
      }

      this.$emit('ok', { user: vm.thisUser })

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-1')
      })
    },
    handleCancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    showForm (value) {
      if (value) {
        this.thisUser = JSON.parse(JSON.stringify(this.user))
        this.thisUser = {
          ...this.thisUser,
          password: '',
          confirmPassword: ''
        }
      }
    }
  }
}
</script>

<style>

</style>
